import mitt from 'mitt';
import { btnTd } from '@/api/typing';

export const event_obj = mitt();
export const btn_list = null;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: btnTd[] = [];
